import { MailingListCollection } from '@/models/MailingList';

export default {
    namespaced: true,
    state: {
        error: null,
        collection: null,
        loaded: false,
    },
    mutations: {
        collection(state, col) {
            state.collection = col;
            state.loaded = true;
        },
        isLoaded(state, loaded) {
            state.loaded = loaded;
        },
        setError(state, error) {
            state.error = error;
        },
    },
    actions: {
        async load({ commit, state }, { force = false } = {}) {
            if (state.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('isLoaded', false);
            const collection = new MailingListCollection();
            commit('collection', collection);
            await collection.query();
            commit('loading', false, { root: true });
        },
    },
};
